import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { MatTooltipModule } from '@angular/material/tooltip';

import { EqualValidatorDirective } from './equal-validator.directive';
import { OneOfTwoDirective } from './one-of-two.directive';
import { SelectOnFocusDirective } from './select-on-focus.directive';
import { DelayClickDirective } from './delay-click.directive';
import { VarDirective } from './ng-var.directive';
import { InjectHTMLDirective } from './inject-html.directive';
import { AutofocusDirective } from './autofocus.directive';

export const Directives = [
  OneOfTwoDirective,
  EqualValidatorDirective,
  SelectOnFocusDirective,
  DelayClickDirective,
  VarDirective,
  InjectHTMLDirective,
  AutofocusDirective
];

@NgModule({
  imports: [
    CommonModule,
    MDBBootstrapModule,
    MatTooltipModule,
  ],
  declarations: Directives,
  exports: Directives
})
export class DirectivesModule { }
